import React from "react";
import { MiniMap } from "@xyflow/react";
import { useTheme } from "@mui/material/styles";

export const ReportBuilderMiniMap = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  return (
    <MiniMap
      style={{
        position: "absolute",
        bottom: 50,
        left: 10,
        padding: 0,
        borderRadius: 6,
        border: `1px solid ${isLight ? "#ccc" : "#555"}`,
        backgroundColor: isLight ? "#fafafa" : "#424242",
        boxShadow: isLight ? "0 0 6px rgba(0,0,0,0.2)" : "0 0 10px rgba(0,0,0,0.8)",
        zIndex: 20,
        width: 185,
      }}
      nodeStrokeColor={(n) => {
        if (n.type === "input") return "#6ede87";
        if (n.type === "output") return "#6865A5";
        if (n.type === "default") return "#00ff00";
        return isLight ? "#444" : "#eee";
      }}
      nodeColor={(n) => {
        if (n.type === "input") return isLight ? "#1976d2" : "#0041d0";
        if (n.type === "output") return isLight ? "#d81b60" : "#ff0072";
        if (n.type === "default") return "#00ff00";
        return isLight ? "#e0e0e0" : "#222";
      }}
      nodeBorderRadius={2}
    />
  );
};
